export const HERO_BANNER_SLIDE_TEST_ID = {
   heroBannerHeading: 'heroBannerHeading',
   heroBannerLabel: 'heroBannerLabel',
   heroBannerSubheading: 'heroBannerSubheading',
};
